module.exports = __webpack_public_path__ + "img/1458901880.6599406f.jpg";